export enum CurrenciesEnum {
  USD = 'usd',
  BRL = 'brl',
}
